import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { OrganizationFormPresentation } from './organization-form-presentation';
import { OrganizationFormVM } from './organization-form.viewmodel';
import { OpenFrom } from '../../../../../tracking-service/tracking-values';

interface IOrganizationFormContainerProps {
    updateOrganizationOnList: () => void;
    closeOrganizationPopup?: () => void;
    accountId: number;
    eventId: number;
    organizationId: number;
    onOrganizationDeletion?: () => Promise<void>;
    openFrom: OpenFrom;
}

const OrganizationFormContainer = withViewModel(
    OrganizationFormPresentation,
    async (props: IOrganizationFormContainerProps) => {
        const organizationFormVM = new OrganizationFormVM(
            props.updateOrganizationOnList,
            props.closeOrganizationPopup,
            props.accountId,
            props.eventId,
            props.organizationId,
            props.onOrganizationDeletion,
            props.openFrom,
        );
        await organizationFormVM.initialize();
        return organizationFormVM;
    },
    props => [props.organizationId]
);

export { OrganizationFormContainer as OrganizationForm };
